/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2019-01-15 19:30:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-06 16:42:03
 */

/**
 * Created by WJX on 2017/11/9.
 */
// TODO: vux


import XInput from 'vux/src/components/x-input';
import Group from 'vux/src/components/group';
import Cell from 'vux/src/components/cell';
import XButton from 'vux/src/components/x-button';
import GroupTitle from 'vux/src/components/group-title';
import XNumber from 'vux/src/components/x-number'; // import { GroupTitle, Group, Cell, XInput, XNumber, XButton } from 'vux';

import { sendMessageCode, registUser, getUserInfo, userInfoRecord, getUsersData, relateRedPackToUser } from '@/api/ajax';
import { mapActions } from 'vuex';
export default {
  name: '',
  data: function data() {
    return {
      jumpjpk: false,
      imgSms: this.$config.javaPath + '/rest/ysh/wx/user/verifyImgCode',
      imgSmsCode: '',
      //图片验证码
      code: '',
      //手机验证码
      phone: '',
      codeBtText: '获取验证码',
      //验证码状态
      canSubmit: false,
      //可否点击
      needVerfyCode: true
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['wxUserInfoAction'])), {}, {
    selectJump: function selectJump() {
      this.jumpjpk = !this.jumpjpk;
    },
    changeEwm: function changeEwm() {
      //更换二维码
      this.imgSms = "".concat(this.$config.javaPath, "/rest/ysh/wx/user/verifyImgCode?v=").concat(new Date().getTime());
    },

    /*
     * 获取验证码
     * */
    getCode: function getCode() {
      var _this = this;

      if (!this.$api.regPhone(this.phone)) {
        this.$vux.toast.show({
          text: '请输入正确手机号',
          type: 'cancel',
          width: '5rem'
        });
        this.changeEwm();
      } else if (!this.imgSmsCode && this.needVerfyCode) {
        this.$vux.toast.show({
          text: '请输入图片验证码',
          type: 'cancel',
          width: '5rem'
        });
        this.changeEwm();
      } else {
        var times = 60;
        var sendData = {
          phone: this.phone
        };

        if (this.needVerfyCode) {
          sendData = Object.assign(sendData, {
            imgVerifyCode: this.imgSmsCode
          });
        }

        sendMessageCode(sendData).then(function (res) {
          _this.codeBtText = "".concat(times, "s");
          var codeInter = setInterval(function () {
            if (times == 0) {
              clearInterval(codeInter);
              _this.codeBtText = '获取验证码';
              times = 60;
            } else {
              times--;
              _this.codeBtText = "".concat(times, "s");
            }
          }, 1000);
          var data = res.data;

          _this.$vux.toast.show({
            text: data.message,
            width: '5rem',
            type: 'success'
          });

          if (data.imgFlag == 1) {
            _this.needVerfyCode = true;
          } // if (data.message == "发送成功") {
          //   this.$vux.toast.show({
          //     text: data.message,
          //     width: '5rem',
          //     type: 'success'
          //   })
          // } else {
          //   if(/请在/.test(data.message)){
          //     this.$vux.toast.show({
          //       text: data.message,
          //       type: 'cancel',
          //       width: '5rem'
          //     })
          //   }else{
          //     this.$vux.toast.show({
          //       text: '图中验证码错误或已过期',
          //       type: 'cancel',
          //       width: '5rem'
          //     })
          //   }
          //
          //   clearInterval(codeInter)
          //   this.codeBtText = "获取验证码"
          //   this.changeEwm()
          // }

        });
      }
    },

    /*
     * 重新授权 并转跳
     * */
    auth: function auth(page) {
      sessionStorage.clear();
      sessionStorage.vueRouterBackPage = location.href.replace('register', 'home');
      location.href = this.$config.wxAuth('');
    },

    /*
     * 提交
     * */
    submitBt: function submitBt() {
      var _this2 = this;

      if (!this.code || !this.$api.regPhone(this.phone)) {
        this.$vux.toast.show({
          text: '请填写正确信息',
          type: 'cancel',
          width: '5rem'
        });
        this.changeEwm();
      } else {
        this.canSubmit = !this.canSubmit;
        var storageData = this.$api.getStorage('wxUserInfo');
        var sendData = {
          phone: this.phone,
          verifyCode: this.code,
          wxOpenId: storageData.wxOpenId
        };

        if (this.needVerfyCode) {
          sendData = Object.assign(sendData, {
            imgVerifyCode: this.imgSmsCode
          });
        }

        registUser(sendData).then(function (res) {
          //提交完善数据
          if (res.data.imgFlag == 1) {
            _this2.needVerfyCode = true;
          }

          var _res$data = res.data,
              data = _res$data.data,
              message = _res$data.message,
              status = _res$data.status;

          if (status == '1') {
            // TODO: 资料库引用同一页面 此为神策兼容处理 已经废弃 埋点更新后删除 doc
            // if(/doc\.jimijiayuan\.cn/.test(location.href)){
            //   sa.track('RegisterEvent', {//埋点
            //     RegisterChannel:'weixin_zlk'
            //   })
            // }else{
            //   sa.track('RegisterEvent', {//埋点
            //     RegisterChannel:'weixin_vzb'
            //   })
            // }
            _this2.$sa.login(data);

            _this2.wxUserInfoAction(data);

            var $vm = _this2;

            _this2.$vux.toast.show({
              text: '注册成功马上为您转跳...',
              // type: 'cancel',
              width: '5rem',
              onHide: function onHide() {
                if ($vm.jumpjpk) {
                  var _location = location,
                      origin = _location.origin;
                  $vm.$sa.setSaSession_href($vm.$route, "".concat(origin, "/html/ess.html#/listCourse"));
                  return false;
                } //活动来源专挑


                if (sessionStorage.strLogin) {
                  var store = $vm.$api.getStorage('strLogin');

                  if (store.from) {
                    if (store.from == 'sleeping') {
                      sa.track('activity', {
                        //睡眠日埋点
                        action: 'Sleep_Day',
                        from: 'wx',
                        type: 'login'
                      });
                    } else if (store.from == 'sendBook') {
                      sa.track('activity', {
                        //埋点
                        action: 'bargain_course',
                        from: 'wx',
                        type: 'registered'
                      });
                    } else if (store.from == 'groupPhoto') {
                      sa.track('activity', {
                        //埋点
                        action: "New_Year's_day_photo",
                        from: 'wx',
                        type: 'click_login_save'
                      });
                    } else if (store.from == 'laba') {} else if (store.from == 'answer') {
                      //新用户从答题来注册
                      relateRedPackToUser({
                        userId: data.id,
                        wxOpenId: data.wxOpenId
                      }).then(function (res) {});
                    } else if (store.from == '2018jk') {
                      sessionStorage.removeItem('strLogin');
                      $vm.$sa.setSaSession_href($vm.$route, "/appRedPacket/happyDragonDay?userId=".concat(data.usersId));
                      return false;
                    }
                  }

                  var rmStr = $vm.$api.getStorage('strLogin');
                  sessionStorage.removeItem('strLogin');
                  $vm.$sa.setSaSession_href($vm.$route, rmStr.url);
                } else if (sessionStorage.authRegisterBack) {
                  var back = sessionStorage.authRegisterBack;
                  sessionStorage.removeItem('authRegisterBack');
                  $vm.$sa.setSaSession_href($vm.$route, back);
                } else if (sessionStorage.vueRouterBackPage) {
                  var _back = sessionStorage.vueRouterBackPage;
                  sessionStorage.removeItem('vueRouterBackPage');
                  $vm.$sa.setSaSession_href($vm.$route, _back);
                } else {
                  if ($vm.$route.query.shareUserId) {
                    $vm.$sa.setSaSession_href($vm.$route, "/html/bargain/index.html#/friendhelp?shareId=".concat($vm.$route.query.shareUserId));
                  } else {
                    $vm.$router.push({
                      name: 'home'
                    });
                  }
                }
              }
            });
          } else {
            _this2.$vux.toast.show({
              text: message,
              type: 'cancel',
              width: '5rem',
              onHide: function onHide() {}
            });

            _this2.canSubmit = !_this2.canSubmit;
          }
        }).catch(function (e) {
          _this2.canSubmit = !_this2.canSubmit;
        }); // this.$vux.alert.show({
        //   title: '123',
        //   content: '验证码错误，请重新获取验证码！',
        //   onShow () {
        //     console.log('Plugin: I\'m showing')
        //   },
        //   onHide () {
        //     console.log('Plugin: I\'m hiding')
        //   }
        // })
      }
    }
  }),
  computed: {},
  components: {
    Group: Group,
    GroupTitle: GroupTitle,
    Cell: Cell,
    XInput: XInput,
    XNumber: XNumber,
    XButton: XButton
  },
  mounted: function mounted() {
    //进入注册
    sa.track('wx_register', {
      pageUrl: location.href,
      pagePosition: 0,
      web_edition: 2
    });
  },
  beforeDestroy: function beforeDestroy() {// cavasAnimate.pause()
  }
};